import { http } from '../../core/services/http';

export const loadDataRetention = () =>
  http.get('/subscriptionPackage/dataRetentionConfiguration').then(response => response.data);
